
import adTextEmpty from '@/components/common/adTextEmpty.vue'
import { fetchPublicConfig } from '@/utils/publicConfig'

export default {
  components: {
    adTextEmpty
  },
  name: 'Favorites',
  data () {
    return {
      favorites: [],
      showTierBadge: true, // "惠/靓/正"角标全局开关（public config 下发；默认显示）
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      btnX: 0,
      btnY: 0,
      hasMoved: false
    }
  },
  mounted () {
    const btn = this.$refs.backBtn
    if (btn) {
      btn.style.left = (window.innerWidth - 70) + 'px'
      btn.style.top = (window.innerHeight - 150) + 'px'
    }
  },
  beforeDestroy () {
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.endDrag)
    document.removeEventListener('touchmove', this.onDrag)
    document.removeEventListener('touchend', this.endDrag)
  },
  created () {
    this.loadFavorites()
    // "惠/靓/正"角标全局开关（默认 true，显式 false 才隐藏）
    fetchPublicConfig().then(cfg => { this.showTierBadge = cfg.showHuiliangzhengBadge !== false })
  },
  methods: {
    goBack () {
      // 与帮助中心同款返回语义：有历史则回上一页，直敲 URL 进入则回首页
      if (window.history.length > 1) this.$router.back()
      else this.$router.replace('/home')
    },
    async loadFavorites () {
      const saved = localStorage.getItem('favorites')
      if (!saved) return
      this.favorites = JSON.parse(saved)
      // 本地快照只保序与 id：实时拉取商品（tier/边框/促销铭牌装饰 + 库存新鲜度），
      // 与首页精选同模式（/products?ids= 出口已批量注入装饰）；失败回落本地快照
      const ids = this.favorites.map(f => f && f.id).filter(Boolean)
      if (!ids.length) return
      try {
        const res = await this.axios.get('products', { params: { ids: ids.slice(0, 50).join(',') } })
        if (res.data.code === 200) {
          const map = {}
          res.data.data.forEach(p => { map[p.id] = p })
          const fresh = ids.map(id => map[id]).filter(Boolean)
          if (fresh.length) this.favorites = fresh
        }
      } catch (_) { /* 网络失败：保留本地快照 */ }
    },
    removeFavorite (id) {
      this.favorites = this.favorites.filter(item => item.id !== id)
      localStorage.setItem('favorites', JSON.stringify(this.favorites))
      this.$q.notify({
        message: '已取消收藏',
        color: 'positive',
        position: 'top',
        timeout: 1000
      })
    },
    toDetails (id) {
      this.$router.push({ path: '/details', query: { id } })
    },
    onBackClick () {
      if (this.hasMoved) return
      this.$router.back()
    },
    startDrag (e) {
      this.isDragging = true
      this.hasMoved = false
      const touch = e.touches ? e.touches[0] : e
      this.dragStartX = touch.clientX
      this.dragStartY = touch.clientY
      const btn = this.$refs.backBtn
      const rect = btn.getBoundingClientRect()
      this.btnX = rect.left
      this.btnY = rect.top
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.endDrag)
      document.addEventListener('touchmove', this.onDrag)
      document.addEventListener('touchend', this.endDrag)
    },
    onDrag (e) {
      if (!this.isDragging) return
      e.preventDefault()
      const touch = e.touches ? e.touches[0] : e
      const dx = touch.clientX - this.dragStartX
      const dy = touch.clientY - this.dragStartY
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        this.hasMoved = true
      }
      const btn = this.$refs.backBtn
      btn.style.left = (this.btnX + dx) + 'px'
      btn.style.top = (this.btnY + dy) + 'px'
      btn.style.right = 'auto'
      btn.style.bottom = 'auto'
    },
    endDrag () {
      if (!this.isDragging) return
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.endDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.endDrag)
      const btn = this.$refs.backBtn
      const rect = btn.getBoundingClientRect()
      const winW = window.innerWidth
      const winH = window.innerHeight
      const margin = 20
      const btnW = 50
      const btnH = 50
      const distLeft = rect.left
      const distRight = winW - rect.right
      const distTop = rect.top
      const distBottom = winH - rect.bottom
      const minDist = Math.min(distLeft, distRight, distTop, distBottom)
      btn.style.transition = 'all 0.3s ease'
      if (minDist === distLeft) {
        btn.style.left = margin + 'px'
        btn.style.top = rect.top + 'px'
      } else if (minDist === distRight) {
        btn.style.left = (winW - margin - btnW) + 'px'
        btn.style.top = rect.top + 'px'
      } else if (minDist === distTop) {
        btn.style.left = rect.left + 'px'
        btn.style.top = margin + 'px'
      } else {
        btn.style.left = rect.left + 'px'
        btn.style.top = (winH - margin - btnH) + 'px'
      }
      setTimeout(() => {
        btn.style.transition = ''
      }, 300)
    }
  }
}
